// extracted by mini-css-extract-plugin
export default {"empty-metric-card":"EmptyMetricCard_empty-metric-card__6Ca-q"};